import React, { useRef, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  CartIcon,
  DownArrow,
  LogoutIcon,
  MyAccountIcon,
} from "../../../../assets/icons/svgicons";
import { ROUTES } from "../../../../routes";
import LogoutModal from "../../Modals/LogoutModal/LogoutModal";
import styles from "./ProfileDropdown.module.scss";
import Cart from "../Cart/Cart";
import { useSelector } from "react-redux";
import dummyProfile from "../../../../assets/images/dummy-profile.png";

const ProfileDropdown = ({ className }) => {
  const [showCart, setShowCart] = useState(false);
  const [show, setShow] = useState(false);
  const userData = useSelector((state) => state?.persist?.userInfo);
  const cartCount = useSelector((state) => state?.persist?.cartCount);
  const dropdownRef = useRef();
  const handleClick = () => {
    if (dropdownRef.current && document.body.clientWidth > 767) {
      // screen size for in sidebar don't close dropdown
      dropdownRef.current.click();
    }
  };
  const isKycApproved = userData?.kyc_status === "APPROVED";

  return (
    <>
      <Dropdown className={`${styles.dropdown} ${className || ""}`}>
        <Dropdown.Toggle
          ref={dropdownRef}
        // className={`${true ? "inactive" : ""}`}
        >
          <img
            src={
              userData?.profile_pic
                ? userData?.profile_url + "" + userData?.profile_pic
                : dummyProfile
            }
            alt="avatar"
          />
          {/* <h5>{userData?.first_name}</h5> */}
          {/* <span>
            <DownArrow />
          </span> */}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {isKycApproved ? (
            <>
              <Link
                onClick={handleClick}
                to={ROUTES.MY_PROFILE}
              >
                My Account{" "}
                <span>
                  <MyAccountIcon />
                </span>
              </Link>
              <Link
                onClick={() => {
                  handleClick();
                  setShowCart(true);
                }}
                to="#"
              >
                My Cart{" "}
                <span className={cartCount > 0 ? "inactive" : ""}>
                  <CartIcon />
                </span>
              </Link>
            </>
          ) : (
            <><Link
              onClick={handleClick}
              to="#"
            >
              My Account{" "}
              <span>
                <MyAccountIcon />
              </span>
            </Link><Link
              onClick={handleClick}
              to="#"
            >
                My Cart{" "}
                <span>
                  <CartIcon />
                </span>
              </Link></>
          )}
          <Link
            to={"#"}
            onClick={() => {
              setShow(true);
              handleClick();
            }}
          >
            Logout{" "}
            <span className={"logout_icon"}>
              <LogoutIcon />
            </span>
          </Link>
        </Dropdown.Menu>
      </Dropdown>
      <LogoutModal show={show} handleClose={() => setShow(false)} />
      <Cart show={showCart} handleClose={() => setShowCart(false)} />
    </>
  );
};

export default ProfileDropdown;
